// @ts-nocheck
import * as $ from 'jquery';
import { Cart } from './Models/Cart';
import { AddRecipientToCartRequest } from './Models/AddRecipientToCartRequest';

export class RecipientSection {
    private recipientListTable: JQuery;
    private recipientListTableBody: JQuery;
    private noRecipientsMessage: JQuery;
    private removeRecipientFromCart: (id: string) => any;

    constructor(private container: JQuery, removeRecipientCallback: (id: string) => any) {
        this.recipientListTable = container.find('.recipient-list-table');
        this.recipientListTableBody = container.find('#recipient-list-tbody');
        this.noRecipientsMessage = container.find('.no-recipients-message');
        this.removeRecipientFromCart = removeRecipientCallback;
        this.initialize();
    }

    public removeRecipient(evt: JQueryEventObject) {
        const id = evt.currentTarget.getAttribute('data-id');
        this.removeRecipientFromCart(id);
    }

    public addRecipientToCart(currentCart: Cart, request: AddRecipientToCartRequest) {
        if (request.groupTicket !== true) {
            request.groupTicket = false;
        }

        currentCart.recipients.push({
            name: request.name,
            department: request.department,
            countryCode: request.countryCode,
            phoneNumber: request.phoneNumber,
            count: request.ticketCount,
            groupTicket: request.groupTicket,
            id: request.id
        });
    }

    public updateRecipientList(currentCart: Cart): void {
        if (currentCart.recipients && currentCart.recipients.length > 0) {
            this.recipientListTable.show();
            this.noRecipientsMessage.hide();

            this.recipientListTableBody.empty();

            let i;
            for (i = 0; i < currentCart.recipients.length; i = i + 1) {
                let recipient = currentCart.recipients[i];

                let row = $('<tr />');
                row.append($('<td class="name" />').text(recipient.name));
                row.append($('<td class="department" />').text(recipient.department));
                row.append($('<td class="phone-number" />').text(recipient.countryCode + recipient.phoneNumber));
                row.append($('<td class="count" />').text(recipient.count));
                row.append($('<td class="remove" />').html(`<button class='btn remove-recipient' data-id='${recipient.id}'><i class="bi bi-trash-fill"></i></button>`));
                this.recipientListTableBody.append(row);
            }
        } else {
            this.noRecipientsMessage.show();
            this.recipientListTable.hide();
        }
    }

    private initialize() {
        this.recipientListTable.on('click', '.remove-recipient', (evt) => this.removeRecipient(evt));
    }
}
